import { push } from 'react-router-redux';

const changeScreen = location => (dispatch) => {
  dispatch(push(location));
};

export default changeScreen;



// WEBPACK FOOTER //
// ./src/actions/router.js